import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { useRefreshOnFocus } from 'hooks/useRefreshOnFocus';

import { useLocalStorage } from './utils/storage';

import { fetchUserData, setUserData } from "services/auth";

import routes from './routes';

import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
    const [user, setUser] = useLocalStorage('user', null);
    const [token, setToken] = useLocalStorage('token', null);

    // const [isMobile, setIsMobile] = useLocalStorage(useState(window.innerWidth < 768));

    useEffect(() => {
        const initializeAuth = async () => {
            const savedToken = localStorage.getItem('token');

            if (!savedToken) {
                setToken(null);
                setUser(null);
            }
        };
        initializeAuth();
    }, [setToken, setUser]);

    // #region Focus
    useRefreshOnFocus(() => {
        const savedToken = localStorage.getItem('token');

        if(savedToken && savedToken !== null && savedToken !== 'null'){
            fetchUserData().then((data) => {
                setUserData(data);
            });
        }
    });
    // #endregion

    return (
        <div className="app">
            <Router>
                <Routes>
                    {routes.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                </Routes>
            </Router>
        </div>
      );
};

export default App;
